import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mains" }
const _hoisted_2 = {
  class: "title",
  style: {"font-size":"14px"}
}
const _hoisted_3 = { style: {"float":"right"} }
const _hoisted_4 = { class: "van-cell__value info-value" }
const _hoisted_5 = { class: "van-cell__value info-value" }
const _hoisted_6 = { class: "van-cell__value info-value" }
const _hoisted_7 = { class: "be-info" }
const _hoisted_8 = { class: "van-cell__value info-value" }
const _hoisted_9 = { class: "van-cell__value info-value" }
const _hoisted_10 = { class: "van-cell__value info-value" }
const _hoisted_11 = { class: "van-cell__value info-value" }
const _hoisted_12 = { class: "van-cell__value info-value" }
const _hoisted_13 = { class: "be-info" }
const _hoisted_14 = { style: {"margin-top":"10px","font-size":"14px","margin-right":"5px"} }
const _hoisted_15 = { style: {"margin-bottom":"5px","text-align":"right"} }
const _hoisted_16 = { style: {"float":"right"} }
const _hoisted_17 = {
  key: 1,
  style: {"text-align":"center","margin":"20px 0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createTextVNode(" 车辆信息 ", -1)),
      _createElementVNode("span", _hoisted_3, "申请时间：" + _toDisplayString(_ctx.info.applyInfo.createTime), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.dataList, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "be-info"
      }, [
        _createVNode(_component_van_cell, { border: false }, {
          title: _withCtx(() => [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "custom-title" }, [
              _createElementVNode("i", null, "*"),
              _createTextVNode(" 车牌号 ")
            ], -1)),
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_van_field, {
                placeholder: "请填写车牌号",
                modelValue: item.plateNum,
                "onUpdate:modelValue": ($event: any) => ((item.plateNum) = $event),
                disabled: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_van_cell, { border: false }, {
          title: _withCtx(() => [
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "custom-title" }, [
              _createElementVNode("i", null, "*"),
              _createTextVNode(" 车主姓名 ")
            ], -1)),
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_van_field, {
                placeholder: "请填写车主姓名",
                modelValue: item.visitorName,
                "onUpdate:modelValue": ($event: any) => ((item.visitorName) = $event),
                disabled: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_van_cell, { border: false }, {
          title: _withCtx(() => [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "custom-title" }, [
              _createElementVNode("i", null, "*"),
              _createTextVNode(" 联系电话 ")
            ], -1)),
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_van_field, {
                placeholder: "请填写联系电话",
                modelValue: item.visitorPhone,
                "onUpdate:modelValue": ($event: any) => ((item.visitorPhone) = $event),
                disabled: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ])
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128)),
    _cache[20] || (_cache[20] = _createElementVNode("div", {
      class: "title",
      style: {"font-size":"14px"}
    }, "被访人信息", -1)),
    _createVNode(_component_van_form, {
      "scroll-to-error": true,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_van_cell, { border: false }, {
            title: _withCtx(() => [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "custom-title" }, [
                _createElementVNode("i", null, "*"),
                _createTextVNode(" 被访人姓名 ")
              ], -1)),
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_van_field, {
                  placeholder: "请填写被访人姓名",
                  modelValue: _ctx.info.applyInfo.beAccessName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.info.applyInfo.beAccessName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell, { border: false }, {
            title: _withCtx(() => [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "custom-title" }, [
                _createElementVNode("i", null, "*"),
                _createTextVNode(" 人员编号 ")
              ], -1)),
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_van_field, {
                  placeholder: "请填写人员编号",
                  modelValue: _ctx.info.applyInfo.beAccessGh,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.info.applyInfo.beAccessGh) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell, { border: false }, {
            title: _withCtx(() => [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "custom-title" }, [
                _createElementVNode("i", null, "*"),
                _createTextVNode(" 到访校区 ")
              ], -1)),
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_van_field, {
                  placeholder: "请填写到访校区",
                  modelValue: _ctx.info.applyInfo.visiCampus,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.info.applyInfo.visiCampus) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell, { border: false }, {
            title: _withCtx(() => [
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "custom-title" }, [
                _createElementVNode("i", null, "*"),
                _createTextVNode(" 到访日期 ")
              ], -1)),
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_van_field, {
                  placeholder: "请填写到访日期",
                  modelValue: _ctx.info.applyInfo.visiStartTime,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.info.applyInfo.visiStartTime) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell, { border: false }, {
            title: _withCtx(() => [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "custom-title" }, [
                _createElementVNode("i", null, "*"),
                _createTextVNode(" 到访事由 ")
              ], -1)),
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_van_field, {
                  placeholder: "请填写到访事由",
                  modelValue: _ctx.info.applyInfo.reason,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.info.applyInfo.reason) = $event)),
                  autosize: "",
                  type: "textarea",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        (_ctx.info.view && _ctx.info.idea)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[17] || (_cache[17] = _createElementVNode("div", {
                class: "title",
                style: {"font-size":"14px"}
              }, "被访人审批", -1)),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_van_cell_group, {
                  inset: "",
                  style: {"border-top":"none !important"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_field, {
                      modelValue: _ctx.info.remark,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.info.remark) = $event)),
                      rows: "2",
                      autosize: "",
                      type: "textarea",
                      maxlength: "50",
                      placeholder: "请输入",
                      "show-word-limit": "",
                      disabled: _ctx.info.view
                    }, null, 8, ["modelValue", "disabled"]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, "审核结果：" + _toDisplayString(_ctx.info.idea == 1 ? '同意' : '不同意'), 1),
                      _createElementVNode("span", null, "审核人：" + _toDisplayString(_ctx.info.shr), 1),
                      _createElementVNode("span", _hoisted_16, "审核日期：" + _toDisplayString(_ctx.info.shdate), 1)
                    ])
                  ]),
                  _: 1
                })
              ])
            ], 64))
          : _createCommentVNode("", true),
        (!_ctx.info.view)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_van_button, {
                class: "btns",
                color: "#E74948",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.info.submit(2)))
              }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("不同意", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_van_button, {
                class: "btns",
                color: "#1989fa",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.info.submit(1)))
              }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createTextVNode("同意", -1)
                ]))]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512)
  ]))
}